import _isEmpty from 'lodash/isEmpty';
import properties from '../modules/ajio-util/properties';
import endpoints from '../modules/ajio-util/endpoints';
import { getVariant } from '../refresh/organism/ABFeature/Feature';
import UTILS from './jioAdsUtils';
// import { jioBannerAdsListingURLS, jioBannerAdsListingAdspotId } from "../constants/constant";

const defaultUrlParams = {
  md_ajiocat: '',
  ai: 'www.ajio.com',
  os: '3',
  ua: '',
  vnm: 'jioads',
  vr: 'web-2.0.10',
  md_utype: 'non_premium',
  md_sis: 'AJIO'
};
// Men___Shirts

// const environment = isNode() ? (process.env.NODE_CONFIG_ENV || process.env.NODE_ENV) : window.__ENV__;
// const isDev = environment === 'uat62';
// const isDev = true;

// const bannerAdsURL = isDev ? jioBannerAdsListingURLS.Stg : jioBannerAdsListingURLS.Prod;
const bannerAdsURL = endpoints.get('jioBannerAdsListing');
const adSpotId = properties.getProperty('jioBannerAdsListingAdspotId');

export const getJioBannerListingUrl = urlParams => {
  const params = { ...defaultUrlParams, ...urlParams };
  // console.log('Jio Ads request params:', params);

  const adSpotIdValue = params?.isLandingAdBanners ? params?.adSpotId : adSpotId;
  const jioAdsURL = new URL(bannerAdsURL);
  jioAdsURL.searchParams.set('trq', Date.now());
  jioAdsURL.searchParams.set('asi', adSpotIdValue);
  params?.os && jioAdsURL.searchParams.set('os', params.os);
  params?.vnm && jioAdsURL.searchParams.set('vnm', params.vnm);
  params?.ifa && jioAdsURL.searchParams.set('ifa', params.ifa);
  params?.ai && jioAdsURL.searchParams.set('ai', params.ai);
  params?.ua && jioAdsURL.searchParams.set('ua', params.ua);
  params?.vr && jioAdsURL.searchParams.set('vr', params.vr);
  params?.md_utype && jioAdsURL.searchParams.set('md_utype', params.md_utype);
  params?.md_sis && jioAdsURL.searchParams.set('md_sis', params.md_sis);
  params?.md_ajiocat && jioAdsURL.searchParams.set('md_ajiocat', params.md_ajiocat);
  params?.vnm && jioAdsURL.searchParams.set('vnm', params.vnm);
  params?.md_user_status && jioAdsURL.searchParams.set('md_user_status', params.md_user_status);
  params?.md_user_restriction &&
    jioAdsURL.searchParams.set('md_user_restriction', params.md_user_restriction);
  params?.md_platform && jioAdsURL.searchParams.set('md_platform', params.md_platform);
  params?.md_channel && jioAdsURL.searchParams.set('md_channel', params.md_channel);
  params?.md_page_url && jioAdsURL.searchParams.set('md_page_url', params.md_page_url);
  params?.md_secondaryid && jioAdsURL.searchParams.set('md_secondaryid', params.md_secondaryid);
  params?.md_pc && jioAdsURL.searchParams.set('md_pc', params.md_pc);
  params?.md_zone && jioAdsURL.searchParams.set('md_zone', params.md_zone);
  params?.md_state && jioAdsURL.searchParams.set('md_state', params.md_state);

  //! important - revert
  // jioAdsURL.searchParams.set('md_ajiocat', 'Men___Shirts');
  return jioAdsURL;
};

function findAllByKey(obj, keyToFind) {
  return Object.entries(obj).reduce(
    (acc, [key, value]) =>
      key === keyToFind
        ? acc.concat(value)
        : typeof value === 'object'
        ? acc.concat(findAllByKey(value, keyToFind))
        : acc,
    []
  );
}
// console.log(resp.result)
export const getJioAdsParsedResponse = resp => {
  const { asi } = resp.result;
  console.log('###asi here', asi);
  const parsedData = [];
  try {
    for (const adSpotid in asi) {
      const adspotobj = asi[adSpotid].cmps.dd;
      // Now put them in sorted ads array
      let adsArray = [];
      for(let key in adspotobj){
        adsArray.push(adspotobj[key]);
      }
      // sort the adsArray
      adsArray.sort((a, b) => parseInt(a.wt) - parseInt(b.wt))
      for (const adObj of adsArray) {
        const { ads, wt = '' } = adObj;
        for (const key2 in ads) {
          const { cid } = ads[key2].config;
  
          const ad = JSON.parse(ads[key2].ad);
  
          parsedData.push({ ...ad, cid, wt });
        }
      }
    }
  } catch (error) {
    console.log('Error parsing jio ads data.')
  }


  return parsedData;

  // return findAllByKey(resp.result, "ad").map(el => JSON.parse(el))
};

export const encodeFacets = str => {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    if (str[i].charCodeAt(0) >= 97 && str[i].charCodeAt(0) <= 122) {
      result += str[i];
    } else if (str[i].charCodeAt(0) >= 65 && str[i].charCodeAt(0) <= 90) {
      result += str[i];
    } else if (str[i].charCodeAt(0) >= 48 && str[i].charCodeAt(0) <= 57) {
      result += str[i];
    } else {
      result += '_';
    }
  }
  return result;
};

export function markBannerPlpIfNeeded(url = '') {
  if (typeof window === 'undefined' || !url) return;
  const path = String(url)
    .split('?')[0]
    .toLowerCase();
  if (path.includes('/s/') || path.includes('/c/') || path.includes('/b/')) {
    localStorage.setItem('isBannerPlp', 'true');
  }
}

export function addRefParamToUrl(enableAdsOnPlp, hotspotUrl) {
  let udpatedUrl = hotspotUrl;
  if (enableAdsOnPlp === false) {
    // condition for checking plp page
    if (
      hotspotUrl.includes('/search/') ||
      hotspotUrl.includes('/s/') ||
      hotspotUrl.includes('/c/') ||
      hotspotUrl.includes('/b/')
    ) {
      try {
        const url = new URL(hotspotUrl.trim());
        url.searchParams.set('ref', 'cmsBanner');
        udpatedUrl = url.href;
      } catch (error) {
        udpatedUrl += '?ref=cmsBanner';
      }
    }
  }
  return udpatedUrl;
}

export function jioAdsLandingBannersParser(data, adSpotId) {
  if (!data?.result || data?.result?.length <= 0) return {};
  const parsedData = {};

  const adobj = data.result?.asi[adSpotId]?.cmps?.dd;

  for (const p_ad_node in adobj) {
    if (parsedData[adobj[p_ad_node]?.wt] === undefined) {
      parsedData[adobj[p_ad_node]?.wt] = [];
    }
    //we will take fwt for sorting the ads based on that
    let {fwt = 0} =  adobj[p_ad_node]
    // fwt will come as string 
    fwt = parseInt(fwt)
    for (const c_ad_node in adobj[p_ad_node]?.ads) {
      const adsData = {
        cid: adobj[p_ad_node]?.ads[c_ad_node]?.config?.cid
      };
      const crobj = JSON.parse(adobj[p_ad_node]?.ads[c_ad_node]?.ad);
      adsData.impression = crobj?.imptrackers[0];
      adsData.clicktracker = crobj?.clktrackers[0];
      adsData.customimage = crobj?.customimage[0];
      adsData.clickthrough = crobj?.ctafb;
      adsData.desc = crobj?.desc2;
      //adding fwt in adsData to sort it
      adsData.fwt = fwt
      parsedData[adobj[p_ad_node]?.wt].push(adsData);
      parsedData[adobj[p_ad_node]?.wt].sort((a, b) => b.fwt - a.fwt)
    }
  }
  return parsedData;
}

function compactArrayofObjects(arr = []) {
  return arr?.filter(element => Object.keys(element)?.length !== 0);
}

function cmsAndJioAdsBannersMergerUtil(cmsBannersData, jioBannerAdsData) {
  const finalBannerData = cmsBannersData?.slots?.map(slotElement => {
    return {
      ...slotElement,
      component: {
        ...slotElement.component,
        banners: compactArrayofObjects(
          slotElement?.component?.banners?.map(bannerData => {
            if (bannerData?.isAdBanner) {
              let jioAdsTobeMerged = {};
              const jioAdsWtArray = jioBannerAdsData[bannerData?.adSpotId] || [];
              if (_isEmpty(jioAdsWtArray)) {
                return {};
              }
              delete jioBannerAdsData[bannerData?.adSpotId];
              const bannerDimension = `${Math.round(
                (bannerData?.width * cmsBannersData?.baseValue?.resolutionWidth) / 100
              )}x${Math.round(
                (bannerData?.height * cmsBannersData?.baseValue?.resolutionHeight) / 100
              )}`.toString();
              for (let i = 0; i < jioAdsWtArray.length; i++) {
                const bannerFound = jioAdsWtArray[i]?.customimage?.[bannerDimension] || '';
                jioAdsTobeMerged = {
                  jioAdImgUrl: bannerFound,
                  cid: jioAdsWtArray[i]?.cid || '',
                  clicktracker: jioAdsWtArray[i]?.clicktracker || '',
                  clickthrough: jioAdsWtArray[i]?.clickthrough || '',
                  impression: jioAdsWtArray[i]?.impression || '',
                  desc: jioAdsWtArray[i]?.desc || '',
                  isJioAdBanner: true
                };
                if(jioAdsWtArray[i]?.customimage?.[bannerDimension]) {
                  delete jioAdsWtArray[i]?.customimage?.[bannerDimension];
                }
                if (bannerFound) break;
              }
              jioBannerAdsData = {
                ...jioBannerAdsData,
                [bannerData?.adSpotId]: jioAdsWtArray
              };
              if (jioAdsTobeMerged?.jioAdImgUrl) {
                return {
                  ...bannerData,
                  ...jioAdsTobeMerged,
                  bannerUrl: jioAdsTobeMerged?.jioAdImgUrl
                };
              }
              return {};
            }

            if(bannerData?.bannerType === 'EXTERNAL_AD') return null;
            return bannerData;
          })
        )
      }
    };
  });
  return finalBannerData;
}

export function cmsAndJioAdsBannersMapper(cmsBannersData, jioBannerAdsData) {
  return {
    ...cmsBannersData,
    data: {
      ...cmsBannersData?.data,
      page: {
        ...cmsBannersData?.data?.page,
        slots: cmsAndJioAdsBannersMergerUtil(
          { ...cmsBannersData?.data?.page, baseValue: cmsBannersData?.data?.baseValue },
          jioBannerAdsData
        )
      }
    }
  };
}


export function sendClickOrImpressionTrackerToJioAds(url, extras={}) {
  const { setCid=false, cid='', jioAdsBannerName=''} = extras;
  const ccb = UTILS.getCCB(jioAdsBannerName);
  
  if(setCid) {
    sessionStorage.setItem('jioads-cid', cid.replaceAll('[ccb]', ccb));
  }

  const finalUrl = url?.replaceAll('[trq]', Date.now()).replaceAll('[ccb]', ccb);
  console.log('TRACK FINAL JIO ADS API ENDPOINT ~ finalUrl:', finalUrl);
  fetch(finalUrl)
    .then(res => {
      console.log('TRACK JIO ADS CLICK OR PROMOTION IMPRESSION FIRED SUCCESSFULLY 🚀', finalUrl);
    })
    .catch(err => {
      console.log('TRACK ERROR IN JIO ADS API');
    });
}

export function getValidCookieValue(cookieValue = '', fallbackValue = '') {
  if (!_isEmpty(cookieValue) && cookieValue !== 'undefined') {
    return cookieValue;
  }
  return fallbackValue;
}

export function filterJioAdsBanners(
  slots = [],
  jioAdsLandingBannersFlag = false,
  landingPagesExperiments = [],
  jioAdsLandingPagesExperiment = ''
) {
  const finalSlotsData = [];
  for (let i = 0; i < slots.length; i++) {
    const slotElement = slots[i];
    const response = {
      ...slotElement,
      component: {
        ...slotElement.component,
        banners: compactArrayofObjects(
          slotElement?.component?.banners?.map(bannerData => {
            const { isAdBanner = false } = bannerData;
            if (!isAdBanner) return bannerData;

            const condition1 = landingPagesExperiments.includes(jioAdsLandingPagesExperiment);
            const condition2 = getVariant(jioAdsLandingPagesExperiment);
            if (condition1 && condition2 && jioAdsLandingBannersFlag) {
              bannerData.isJioAdBanner = true;
              console.log('TRACK JIO ADD BANNER TRUE....................', bannerData);
              return bannerData;
            }
            console.log('TRACK JIO ADD BANNER FALSE....................', bannerData);
            return {};
          })
        )
      }
    };
    finalSlotsData.push(response);
  }
  return finalSlotsData;
}

export const checkBannerImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  const response = getLocalData?.indexOf(promoId) !== -1;
  return response;
};

export const setBannerImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  if (getLocalData?.indexOf(promoId) === -1) {
    getLocalData?.push(promoId);
    localStorage.setItem(localVariable, JSON.stringify(getLocalData));
  }
}

export const getBundleBannerImpressionArray = (localVariable = '', includeData = false) => {
  let data = JSON.parse(localStorage.getItem(localVariable)) || {};
  return includeData ? data : (data?.promotionArray || []);
}

export const setBundleBannerImpressionArray = (localVariable = '', promotionArray = [], promotionData = {}) => {
  let getLocalData = JSON.parse(localStorage.getItem(localVariable)) || {};
  getLocalData = {
    ...getLocalData,
    promotionArray: promotionArray,
    promotionData: promotionData
  }
  localStorage.setItem(localVariable, JSON.stringify(getLocalData));
}
export const emptyBundleBannerImpressionArray = (localVariable = '') => {
  localStorage.removeItem(localVariable);
}